'use client';
import React from 'react';
import SectionHeader from '@/components/common/section-header';
import TextAnimate from '@/components/magicui/text-animate';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const AboutSectionClient = () => {
  return (
    <section>
      <SectionHeader
        sl={'02'}
        primaryText={'About Us'}
        secondaryText={'Discover who we are'}
      />

      <div className={'padding-x-header'}>
        <TextAnimate
          className={'text-body text-xl leading-snug font-medium md:mx-[16vw] md:text-3xl'}
          as={'p'}
          animation="slideLeft"
          stagger={0.02}
          duration={1.2}
          delay={0}
          by="word"
          startOnView
          once>
          Ucon Fixings is a leading industrial company specializing in the manufacturing and
          fabrication of high-quality metal products. Our solutions include Pipe Support
          Systems, Fasteners, Anchors, HVAC components, Anti-Vibration Systems, and equipment
          for industrial, commercial, utility, and OEM applications.
        </TextAnimate>

        <div className={'relative mx-auto mt-10 w-full max-w-full md:mt-30 md:max-w-2/3'}>
          <div
            className="absolute inset-0 bg-linear-to-r from-white via-transparent to-white dark:from-black
              dark:to-black"
          />
          <DotLottieReact
            /*src="https://lottie.host/9911339e-c554-4e06-ae10-f1659067296f/uIVCT1ABCg.lottie"*/
            src="https://lottie.host/b3a4c2aa-b729-427b-b27e-8d53b91e5982/oei015Shre.lottie"
            loop
            autoplay
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSectionClient;
